import React from 'react';

export default function AppSettingsPlaceholderContent({ pageTitle = '' }) {
  return (
    <div className="app-settings-section simple-page-placeholder">
      <h2 className="simple-page-title">{pageTitle}</h2>
      <p className="simple-page-subtitle">
        Manage {String(pageTitle || '').toLowerCase()} for your organization. Connect this screen to your admin APIs
        when ready.
      </p>
    </div>
  );
}
